import _ from 'lodash';

export default class ShapeMemory {
  __shape;
  memory = {
    pos: {x: 0, y: 0},
    slabPos: {x: 0, y: 0},
    absolutePos: {x: 0, y: 0}
  };

  constructor(shape) {
    this.__shape = shape;
  }

  rememberShapePosition = () => {
    this.memory = {
      pos: _.clone(this.__shape.pos),
      slabPos: _.clone(this.__shape.slabPos),
      shapeSlabAbsolutePos: _.clone(this.__shape.shapeSlab.getAbsolutePosition()),
      shapeAbsolutePos: _.clone(this.__shape.shapeAbsolute.getAbsolutePosition())
    }
  }

  restoreShapePosition = () => {
    this.__shape.pos = _.clone(this.memory.pos)
    this.__shape.slabPos = _.clone(this.memory.slabPos)
    this.__shape.shapeSlab.setAbsolutePos( _.clone(this.memory.shapeSlabAbsolutePos));
    this.__shape.shapeAbsolute.setAbsolutePos( _.clone(this.memory.shapeAbsolutePos));
  }
}
